import { MTableCell } from "@material-table/core";
import className from "classnames";
import { GOVGR_TABLE__CELL } from "../../../../conf/styles/GovGrTable";
const GovGrTableCell = (props) => {
  let ComponentWrapperClass = className(GOVGR_TABLE__CELL);
  return <MTableCell className={ComponentWrapperClass} {...props} />;
};

export default GovGrTableCell;
